import React from 'react';
import { useCollection } from '@tribeplatform/react-sdk/hooks';
import { PageHeader } from '@tribeplatform/react-ui-kit/PageHeader';
import { CollectionHeaderActionButtons } from './CollectionHeaderActionButtons.js';
export const CollectionHeaderBlock = ({ collectionId, }) => {
    const { data: collection } = useCollection({
        variables: { id: collectionId },
        fields: {
            space: 'all',
        },
    });
    return (React.createElement("div", { className: "py-3" },
        React.createElement(PageHeader, { title: collection === null || collection === void 0 ? void 0 : collection.name, description: collection === null || collection === void 0 ? void 0 : collection.description, action: React.createElement(CollectionHeaderActionButtons, { collection: collection }) })));
};
//# sourceMappingURL=Block.js.map